// Olika typer av scanningar
export const SCAN_INPUT_TYPE_UNDEFINED = -1;
export const SCAN_INPUT_TYPE_CART = 10;
export const SCAN_INPUT_TYPE_EAN = 20;
export const SCAN_INPUT_TYPE_SKU = 30;
export const SCAN_INPUT_TYPE_2D = 40;
export const SCAN_INPUT_TYPE_UNDO_SKU = 50;
export const SCAN_INPUT_TYPE_CHANGE_SHELF = 60;
export const SCAN_INPUT_TYPE_FAKTURA = 70;
export const SCAN_INPUT_TYPE_BOXID = 80;
export const SCAN_INPUT_TYPE_BOXBARCODE = 90;
export const AUTOSTORE_SHELF = "AS01A1";
export const RX_BAG_SKU = 70000000;

export const ActionTypes = {
  REQUEST_CART: 10,
  SET_CART: 20,
  GET_SHELF: 30,
  SCAN_ARTICLE: 40,
  INITIALIZE_BOX_CHECK: 50,
  WAITING_FOR_SINGLE_ARTICLE_SCAN: 60,
  SEARCH_BOX: 70,
  SET_BOX_MANUALLY: 80,
};

export const CartType = {
  Undefined: -1,
  NORMAL_CART: 1,
  MULTI_CART: 2,
  SINGEL_CART: 3,
  FROM_REVIEW: 4,
};

export const SortBoxModelReturnType = {
  NEW_SORT_BOX: 10,
  TAKE_OTHER_CART: 20,
  NOONE_IN_CHARGE: 30,
  PACKING_NOT_ALLOWED: 40,
  RX_SINGLE_BLOCKED: 50,
  NO_PERMISSION: 70,
  PENDING_BOXES: 80,
  STATION_NOT_ALLOWED: 90,
  MULTIPLE_SORTS_CART: 100,
  NOT_FOUND: 510,
  RX_SINGEL_NOT_FOUND: 520,
};

export const SHELF_SCAN_ERRORS = {
  INCORRECT_TYPE: "Den skannade sträckkoden är inte är inte ett hyllnummer. Vänligen försök igen.",
};

export const BOX_ITEM_VERIFICATION_ERRORS = {
  ITEM_NOT_IN_ORDER: "Artikeln är inte en del av den aktuella ordern.",
  FORCE_CONTINUE_WITH_SCANNED_ITEM:
    "Vänligen avsluta den redan påbörjade inskanningen innan du skannar nästa artikel.",
  ALL_ITEMS_VERIFIED:
    "Det finns inga återstående artiklar att verifiera – alla är redan behandlade. Var god och tryck på 'Skannat klart'-knappen.",
  MAX_VERIFIED_REACHED: (identifier) =>
    `Det maximala antalet verifierade artiklar med identifikationsnummer '${identifier}' har redan uppnåtts.`,
  FINISH_VERIFICATION_FAILED: "Verifiering av lådans innehåll kunde inte slutföras.",
};

export const LIMA_WORKSTATIONS = {
  "VBG-CHK-FIN1": 7205,
  "VBG-CHK-FIN2": 7206,
  "VBG-CHK-RX": 7207,
};

export const RUN_SIGNALR = !(
  process.env.NODE_ENV === "development" && process.env.REACT_APP_RUN_SIGNALR === "false"
);
export const API_PATH = process.env.REACT_APP_API_PATH;
export const IPACK_PATH = process.env.REACT_APP_IPACK_PATH;
export const SERVICES_BASE_URL = process.env.REACT_APP_SERVICES_BASE_URL || "https://services.site.se";
export const MESSAGEHUB_PATH = process.env.REACT_APP_MESSAGEHUB_PATH;
export const RXCONTROLLER_API_PATH = process.env.REACT_APP_RXCONTROLLER_API_PATH;
export const BASE_ROUTER_ROUTE = process.env.REACT_APP_BASE_ROUTER_ROUTE;

export const PREPROD_PATH = process.env.REACT_APP_PREPROD_PATH;
export const PROD_PATH = process.env.REACT_APP_PROD_PATH;

export const SortType = {
  Undefined: -1,
  SINGEL: 1,
  NORMAL: 2,
  AFRAME: 3,
  AFRAMEMIXEDSINGLE: 5,
  AFRAMEMIXEDNORMAL: 6,
};

export const VIEW = {
  APP: 0,
  REVIEW: 1,
  SETTIGNS: 2,
  AFRAME: 3,
  RX: 4,
  AUTOSTORE: 5,
  VARBERG: 6,
};

export const KeyPadKeyCode = {
  BACKSPACE: "backspace",
  ONE: "1",
  TWO: "2",
  THREE: "3",
  FOUR: "4",
  FIVE: "5",
  SIX: "6",
  SEVEN: "7",
  EIGHT: "8",
  NINE: "9",
  ZERO: "0",
  ENTER: "enter",
  K: "K",
};

export const ClientMessageType = {
  BOX_READ_AT_TABLE: 500,
  BOX_DELIVERY_REQUEST: 1000,
  BOX_EJECT_REPORT: 2000,
  BOX_RESET_RESPONSE: 3000,
  ERROR_SET_WORKSTATION: 5001,
  ERROR_BOX_READ: 5002,
  ERROR_BOX_USED: 5003,
  ERROR_BOX_UNDEFINED: 5004,
};

export const ValidationResult = {
  0: "OK",
  1: "NoRead",
  2: "Fel vikt",
  3: "Fel fraktetikett",
  4: "Okopplad låda",
};

export const LimaCompanyID = {
  undefined: -1,
  ApoteaAB: 1,
  HappyYachtingAB: 2,
  BabylandAB: 3,
  DeliteaAB: 4,
  WidforssAB: 5,
  SmartaSakerAB: 6,
};

export const LimaShopID = {
  undefined: -1,
  Vitaminvaruhuset: 2,
  HappyYachting: 3,
  Babyland: 4,
  Apotea: 6,
  Delitea: 8,
  WidForss: 9,
  StorOchLiten: 10,
  Lekia: 11,
  LitenLeker: 12,
  SmartaSaker: 13,
  WidforssNo: 14,
  LekiaNo: 15,
  HappyYachtingNo: 16,
  BabylandNo: 17,
  SmartaSakerNo: 18,
  SmartaSakerCom: 19,
  Retkitukku: 20,
  Koiravaruste: 21,
};

export const SortCartValidationResult = {
  OK: 1,
  FaultyCartNumber: 2,
  WrongCompany: 3,
  NoSortAssigned: 4,
  UnauthorizedCompany: 6,
  ShowMessage: 7,
};

export const LimaOrderStatus = {
  undefined: -1,
  Mottagen: 10,
  Orderkontroll: 20,
  Kontrollerad: 40,
  Levererad: 100,
  Struken: 510,
  Frusen: 520,
  Utredning: 530,
};

export const LimaShippingStatus = {
  undefined: -1,
  Packad: 5,
  Skickad: 10,
  Makulerad: 510,
};

export const PackagingTypes = {
  Neutral: 0,
  Apotea: 1,
};

export const LimaOperatorTask = {
  Undefined: -1,
  Plock: 10,
  Pack: 20,
  HämtaVag: 21,
  BytVagn: 22,
  HjälpPlats: 23,
  Fortsätt: 24,
  Inleverans: 30,
  Inventering: 40,
  PlockRX: 110,
  ExpeditionRX: 120,
  InleveransRX: 130,
  InventeringRX: 140,
};

export const MissingStockItemRemovalResolutionActions = {
  Cancelled: 0,
  CancelledWithAlternatives: 1,
  Confirmed: 2,
  NotFound: 3,
};
export const WorkstationTypes = {
  RXSatellitBlockad: -20,
  RXSingelBlockad: -10,
  RXBlockad: -2,
  PackBlockad: -1,
  unknown: 0,
  Pack: 1,
  RX: 2,
  RXAuto: 3,
  RXsingel: 10,
  AutostoreTransit: 20,
  AutostoreAutomation: 25,
  RXSatellit: 20,
  AFrame: 30,
  AutoPackSmall: 33,
  AutoPackMedium: 36,
  AutoPackLarge: 60,
  AutoPackXLarge: 70,
  AutoPackMixedSmall: 73,
  AutoPackWestMixedSmall: 74,
  AutoPackMixedMedium: 76,
  AutoPackWestMixedMedium: 77,
  Review: 99,
};

export const MissingStockItemMissingReason = {
  Unknown: "-1",
  Missing: "1",
  Defective: "2",
};

export const LimaInvoiceStatus = {
  Undefined: -1,
  Skapad: 10,
  Packadväntande: 15,
  Öppen: 20,
  Struken: 510,
};

export const ClientEvents = {
  ModalPoppedUp: "ModalPoppedUp",
  ModalPoppedUpExtendedInfo: "ModalPoppedUpExtendedInfo",
  ScanRXBag: "ScanRXBag",
  BetaVersionRedirect: "BetaVersionRedirect",
  IncorrectRXBagScan: "IncorrectRXBagScan",
};

export const GeneralErrorMessage = "Något gick fel, RING IT.";

export const WarningModalOnCloseFunctionKey = {
  Logout: "LOGOUT",
};

export const LogAction = {
  none: 0,
  LOGIN: 1,  
  LOGOUT: 2,
};

export const SORT_EXPIRATION_TIME_MS = 10 * 60 * 60 * 1000;
